<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="editLark"
  >
    <Form
      ref="form"
      :form-data="formData"
      @submit="submitHandle"
    ></Form>
  </sliderBarDialogShell>
</template>

<script>
import { editMt4Config } from "@/api/sys/robitConfig/mt4";
import Form from '@/components/sys/robitCofig/mt4List/Form'

export default {
  name: 'edit',
  components:{
      Form,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
    }
  },
  data() {
    return {
      title: '修改MT4推送渠道'
    }
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },
    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
        let params = {
          id: formData.id,
          name: formData.robitName,
          apiUrl: formData.apiUrl,
          remark: formData.remark,
          status: formData.status,
        }
      editMt4Config(params).then((res) => {
            this.$refs.form.$refs.form.clearValidate();
            this.$refs.form.$refs.form.resetFields();
            this.$emit('edit-success');
            this.$refs.form.reset();
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
